export class FAQ {
    question: string;
    category: string[];
    answer: string;
    link: string;
}